// Translations
import en from "locales/en/translation.json";
import fr from "locales/fr/translation.json";

export const generalInfoFields = [
  {
    id: "name",
    label: "Name",
    type: "text",
    autoComplete: "name",
  },
  {
    id: "domain",
    label: "Domain",
    type: "text",
  },
];

export const clientAppointmentOptions = [
  {
    id: 1,
    key: "appointmentLocations",
    label: "Appointment Locations",
    description: "Filter appointments based on location",
  },
  {
    id: 2,
    key: "appointmentReasons",
    label: "Appointment Reasons",
    description: "Filter appointments based on reason for visit",
  },
];

export const locationFields = [
  {
    id: "location",
    label: "Location (EN)",
    language: "en",
    type: "text",
  },
  {
    id: "location",
    label: "Location (FR)",
    language: "fr",
    type: "text",
  },
];

export const locationInformationFields = [
  {
    id: "information",
    label: "Banner Information (EN)",
    language: "en",
    lang: "English",
    type: "text",
    multiline: true,
  },
  {
    id: "information",
    label: "Banner Information (FR)",
    language: "fr",
    lang: "French",
    type: "text",
    multiline: true,
  },
];

export const reasonsFields = [
  {
    label: "Reason for Visit (EN)",
    language: "en",
    type: "text",
  },
  {
    label: "Reason for Visit (FR)",
    language: "fr",
    type: "text",
  },
];

export const optionalSettingsFields = [
  {
    id: "fullyBookedHelperText",
    label: "Fully Booked Helper Text",
    description: `Toggle this on to show a custom message when patients can't see any available appointment slots on a clinic.  
        **English:** ${en.availableAppointments.fullyBookedHelper}  
        **French:** ${fr.availableAppointments.fullyBookedHelper}
        `,
  },
];
